export default __webpack_public_path__ + "static/media/icon_result_1.8a76d6de.svg";